import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
export default function AdminViews() {
    return (
        <Suspense fallback={<Loading cover="content"/>}>
        <Switch>

          
          {/* <Route path={`${APP_PREFIX_PATH}/employee`} component={lazy(() => import(`./empolyee`))} />
          <Route path={`${APP_PREFIX_PATH}/department`} component={lazy(() => import(`./department`))} />
          <Route path={`${APP_PREFIX_PATH}/excel`} component={lazy(() => import(`./excel-management`))} />
          <Route path={`${APP_PREFIX_PATH}/media`} component={lazy(() => import(`./media`))} /> */}
          <Route path={`${APP_PREFIX_PATH}/dashboard`} component={lazy(() => import(`./dashboard`))} />
          <Route path={`${APP_PREFIX_PATH}/timeslotes`} component={lazy(() => import(`./timeslotes`))} />
          <Route path={`${APP_PREFIX_PATH}/settings`} component={lazy(() => import(`./settings`))} />
          <Route path={`${APP_PREFIX_PATH}/vip`} component={lazy(() => import(`./vip`))} />
          <Route path={`${APP_PREFIX_PATH}/public`} component={lazy(() => import(`./public`))} />
          
          
          <Route exact path={APP_PREFIX_PATH}>
            <Redirect to={`${APP_PREFIX_PATH}/dashboard`} />
          </Route>
        </Switch>
      </Suspense>
    )
}
